const initialState = {};

function reducer(state = initialState, action) {
    if (action.type === 'PATH_CHANGED') {
        if (state.currentPath) {
            if (
                state.pathAfterRouteChange &&
                !action.payload.startsWith(state.pathAfterRouteChange)
            ) {
                return {
                    ...state,
                    currentPath: action.payload,
                    pathAfterRouteChange: undefined,
                    pathBeforeRouteChange: undefined,
                };
            }

            const [, currentPathArray] = action.payload.split('/');
            const [, lastPathArray] = state.currentPath.split('/');

            if (
                currentPathArray !== lastPathArray ||
                (state.currentPath === '/tickets' &&
                    /\/tickets\/tickets\/[0-9]/.test(action.payload))
            ) {
                return {
                    ...state,
                    currentPath: action.payload,
                    pathAfterRouteChange: action.payload,
                    pathBeforeRouteChange: state.currentPath,
                };
            }
        }

        return { ...state, currentPath: action.payload };
    }

    return state;
}

export default reducer;
